import React from "react";
import { classnames } from "@culturehq/components";

const makeClassName = props => classnames({
  "text-center": props.textCenter,
  "text-large": props.textLarge,
  "text-left": props.textLeft
});

const Typography = ({ children, ...props }) => (
  <div className={makeClassName(props)}>
    {children}
  </div>
);

export default Typography;
